var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EEF0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 17.5992C30.7584 17.5992 33.4037 18.6949 35.3541 20.6453C37.3045 22.5957 38.4002 25.241 38.4002 27.9992C38.4002 30.7575 37.3045 33.4028 35.3541 35.3531C33.4037 37.3035 30.7584 38.3992 28.0002 38.3992V17.5992ZM28.0002 15.1992C24.6054 15.1992 21.3497 16.5478 18.9492 18.9483C16.5488 21.3487 15.2002 24.6044 15.2002 27.9992C15.2002 31.394 16.5488 34.6497 18.9492 37.0502C21.3497 39.4507 24.6054 40.7992 28.0002 40.7992C31.395 40.7992 34.6507 39.4507 37.0512 37.0502C39.4516 34.6497 40.8002 31.394 40.8002 27.9992C40.8002 24.6044 39.4516 21.3487 37.0512 18.9483C34.6507 16.5478 31.395 15.1992 28.0002 15.1992Z",
    fill: "#394141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodes);
export default __webpack_public_path__ + "static/media/nodes.029f7725120e65a767f226e79e140941.svg";
export { ForwardRef as ReactComponent };